/* eslint-disable new-cap */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useOutletContext } from 'react-router-dom';
import * as Yup from 'yup';
import { IReport } from '../../../interfaces/Models';
import { reportTypes } from '../../../common/Constants';
import ErrorMessage from '../../../components/ErrorMessage';
import HMMFirstFields from './fields/HMMFirstFields';
import { HMMFirstValues } from '../../../common/reportsFieldsValues/hmm/HMMFirstValues';
import ReportsForm from '../../../components/Form/ReportsForm';

const HMMRelease = () => {
  const { t } = useTranslation();
  const { visitId } = useParams();
  const data: IReport | null = useOutletContext();

  const initialValues =
    data && data.name
      ? data
      : {
          name: reportTypes.HMM_RELEASE,
          visit: visitId,
          data: data ? data : HMMFirstValues,
        };
  const ReportSchema = Yup.object({
    name: Yup.string().required(t('clinic.form.required')),
    visit: Yup.string().required(t('clinic.form.required')),
    data: Yup.object().shape({}),
  });

  if (data?.name && data.name != reportTypes.HMM_RELEASE) {
    return <ErrorMessage error={t('global.errors.somethingWrong')} />;
  }

  const htmlId = 'HMMRelease';
  return (
    <ReportsForm
      initialValues={initialValues}
      visitId={visitId || ''}
      validationSchema={ReportSchema}
    >
      <HMMFirstFields id={htmlId} />
    </ReportsForm>
  );
};

export default HMMRelease;
